import { Link } from 'react-router-dom';
import React, { useState,useEffect } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import ghadminapi from '../api/ghadminapi';
import loginapi from '../api/login';
import { FaPlusCircle } from "react-icons/fa";

import { APISERVERURL } from '../APIServerURL';
import GuestHouseComponent from '../components/GuestHouseComponent';


function ViewAGuestHouse({accessToken,setAccessToken, setRefreshFailed}) {
  const navigate = useNavigate();  
  const { gh_code} = useParams();
  const [formListLoaded,setFormListLoaded]=useState(false);
  const [registrationForm,setRegistrationForm]=useState(null);
  const [isAppLoaded,setIsAppLoaded]=useState(true);

  const saveForm=async ()=>{
    try{       
      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
      const response=await ghadminapi.post('/saveGuestHouse',{registrationForm},{headers:{'Authorization':`Bearer ${accessToken}`}});  
      //setRegistrationForm(response.data.registrationForm);
      //setFormListLoaded(true);
      //alert(JSON.stringify(response.data));
      }
      catch(err)
      {
        if( err.response.status===403)
          {
            navigate(`/accessdenied`); 
          }
        try{
          const config = { withCredentials: true };
          const x=await loginapi.get('/getAccessToken',config);            
          const nat=x['data']['accessToken'];
          const lt=x['data']['loginType'];
          //alert(nat);
          setAccessToken(nat);
          setRefreshFailed(false);  
                  
         
            if(lt.toLowerCase()==="admin")
              {
                    try{       
                      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                      const response=await ghadminapi.post('/saveGuestHouse',{registrationForm},{headers:{'Authorization':`Bearer ${nat}`}});   
                      //setRegistrationForm(response.data.registrationForm);
                      //setFormListLoaded(true);
                      //alert(JSON.stringify(response.data));
                  }
                  catch(err)
                  {
                    if( err.response.status===403)
                      {
                        navigate(`/accessdenied`); 
                      }
                    //alert('refresh failed unusual'+JSON.stringify(err));
                    setAccessToken('');
                    setRefreshFailed(true);  
                  }
                }
          }
          catch(err)
          {
            //alert('dd');
            setAccessToken(''); 
            setRefreshFailed(true);              
          }
      }         
       finally
          {
            //setIsAppLoaded(true);
            //alert('app loaded'+accessToken);
            //setFormListLoaded(true);
          }
  }


  const loadForm=async ()=>{
    setFormListLoaded(false);
    try{       
      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
      const response=await ghadminapi.post('/getGuestHouseDetails',{gh_code},{headers:{'Authorization':`Bearer ${accessToken}`}});  
      setRegistrationForm(response.data.registrationForm);
      setFormListLoaded(true);
      //alert(JSON.stringify(response.data));
      }
      catch(err)
      {
        if( err.response.status===403)
          {
            navigate(`/accessdenied`); 
          }
        try{
          const config = { withCredentials: true };
          const x=await loginapi.get('/getAccessToken',config);            
          const nat=x['data']['accessToken'];
          const lt=x['data']['loginType'];
          //alert(nat);
          setAccessToken(nat);
          setRefreshFailed(false);  
                  
         
            if(lt.toLowerCase()==="admin")
              {
                    try{       
                      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                      const response=await ghadminapi.post('getGuestHouseDetails',{gh_code},{headers:{'Authorization':`Bearer ${nat}`}});   
                      setRegistrationForm(response.data.registrationForm);
                      setFormListLoaded(true);
                      //alert(JSON.stringify(response.data));
                  }
                  catch(err)
                  {
                    if( err.response.status===403)
                      {
                        navigate(`/accessdenied`); 
                      }
                    //alert('refresh failed unusual'+JSON.stringify(err));
                    setAccessToken('');
                    setRefreshFailed(true);  
                  }
                }
          }
          catch(err)
          {
            //alert('dd');
            setAccessToken(''); 
            setRefreshFailed(true);              
          }
      }         
       finally
          {
            //setIsAppLoaded(true);
            //alert('app loaded'+accessToken);
            setFormListLoaded(true);
          }
  }


  useEffect(()=>{
    loadForm();
  },[]);

  return (
    <main className="w-full">
     <div className="flex flex-col items-center w-full">


         <div className="w-full bg-red-100 relative py-1">
            {/* Heading */}
            <h1 className="text-2xl  text-gray-400 text-center">{formListLoaded && (<span>{registrationForm.name.toUpperCase()}</span>)} DETAILS</h1>
            <p className='text-center text-xs'>
            (The form is auto-saved.)
            </p>
          </div>         
        
          {formListLoaded &&(
            <div className="w-full bg-gray-100 mt-2 py-1 flex flex-wrap gap-4 justify-center items-center min-h-[150px]">
              <GuestHouseComponent
              registrationForm={registrationForm}
              setRegistrationForm={setRegistrationForm}
              saveForm={saveForm}
              >

              </GuestHouseComponent>
            </div>
          )}          
     </div>
    {
   (!formListLoaded) && <div className="w-[98%] max-w-[1200px]">
    Please wait!
    </div>
    }
    </main>
  );
  }
  
  export default ViewAGuestHouse